import './map.scss';

import 'leaflet/dist/leaflet.css';
import L from 'leaflet';

class Map {
    constructor ($element) {
        this.$mapRoot = $element;
        this.$mapContainer = this.$mapRoot.querySelector('[data-map="map-container"]');
        this.$mapDisclaimer = this.$mapRoot.querySelector('[data-map="disclaimer"]');
        this.$mapAccept = this.$mapDisclaimer.querySelector('[data-map="accept"]');

        this.mapLatitude = window.MAP_CONFIG.LATITUDE;
        this.mapLongitude = window.MAP_CONFIG.LONGITUDE;
        this.mapZoom = window.MAP_CONFIG.ZOOM;

        let elapsedTime = 0;
        const maxTime = 10000;

        const intervalId = setInterval(() => {
            if (ppms) {
                clearInterval(intervalId);
                this.initialize();
            } else if ((elapsedTime += 100) >= maxTime) {
                clearInterval(intervalId);
                console.warn("Timeout: Cookie consent not found.");
            }
        }, 100);
    }

    initialize () {
        const onFulfilled = (settings) => {
            if (settings.consents.analytics.status === 1) {
                this.initMap();
                this.$mapDisclaimer.remove();
            } else {
                this.$mapAccept.onclick = () => {
                    const onFulfilled = () => {
                        window.location.reload();
                    };

                    ppms.cm.api('setComplianceSettings', {consents: {analytics: {status: 1}}}, onFulfilled);
                };
            }
        };

        ppms.cm.api('getComplianceSettings', onFulfilled);
    }

    initMap () {
        // Creating map options
        const mapOptions = {
            center: [
                this.mapLatitude, this.mapLongitude
            ],
            zoom: this.mapZoom
        };

        // Creating a map object
        const map = new L.map(this.$mapContainer.id, mapOptions);

        // Creating a Layer object
        const layer = new L.TileLayer('http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png');

        let marker = new L.Marker([this.mapLatitude, this.mapLongitude]);
        marker.addTo(map);

        // Adding layer to the map
        map.addLayer(layer);

        // do we need a custom icon for the map?
        // const markerPin = this.$mapContainer.querySelector('.leaflet-pane.leaflet-marker-pane img');
        // markerPin.src = '/static/images/map-pin-blue.png';
        // markerPin.style.width = "46px";
        // markerPin.style.height = "46px";
    }
}

export { Map };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    const $$maps = $context.querySelectorAll('[data-map="root"]');

    if ($$maps.length > 0) {
        $$maps.forEach(($map) => {
            const map = new Map($map); // eslint-disable-line
        });
    }
});